import React, { useMemo } from "react";
import { WidgetProps } from '@rjsf/core';
import { List, ListItemProps, DropdownProps } from "semantic-ui-react";
import { SemanticShorthandCollection } from "semantic-ui-react/dist/commonjs/generic";
import { schemaToRows } from "../../../schema.helpers";
import { useSchemaTranslation } from "../../../useSchemaTranslation";

export const ToggleListDisplay: React.FC<WidgetProps> = ({ id, value = {}, options = {}, schema, formContext }) => {
    const { t } = useSchemaTranslation();


    const rows = useMemo(() => {

        const getLabel = (subSchema: any) => t(subSchema.title)
        let rows = schemaToRows(schema, getLabel);

        if (!rows) {
            rows = (options as any).rows.map((row: DropdownProps) => {
                return { ...row, text: t(`schema:${row.text}`) };

            });
        }

        return rows as { text: string, value: string }[];

    }, [schema, t, options])


    // options.rows MUST be an array, otherwise we'll stubbornly refuse rendering
    if (!Array.isArray(rows)) {
        return <p>Konfiguraatiovirhe</p>
    }

    // Generate a validated version of the values to ensure thate
    // a) it's an object
    // b) it contains all fields with appropriate bool values
    const validValues: { [v: string]: boolean } = ((v: any) => {
        if (typeof (v) !== "object") {
            return {};
        }

        const source = v || {};

        return rows.reduce((values, row) => {
            return {
                ...values,
                [row.value]: !!source[row.value],
            };
        }, {});
    })(value);

    // Filter the row list to create a new array with only the rows which have been checked
    const trueValues = (rows ?? []).filter(({ value }) => validValues[value]);

    // If no rows are checked....render a line :P
    if (!trueValues || trueValues.length === 0) {
        return (
            <div className="filled_value_container">
                <p>{formContext.emptyValue}</p>
            </div>
        )
    }

    // If one or more rows are checked, render the relevant rows

    const items: SemanticShorthandCollection<ListItemProps> = trueValues.map(({ value, text }) => ({
        key: value,
        content: text,
    }));

    return (
        <div id={id} className="filled_value_container">
            {items.length ? (
                <List bulleted items={items} />

            ) : "-"}


        </div >
    );
};
